import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, OnInit } from "@angular/core";
import { AZURE_MAPS_LAYER_OPTIONS } from "../..";
import { AzureMapsOptions } from "../../../shared/models/azure-maps.models";
import { AZURE_MAPS_SUBSCRIPTION_KEY } from "../../../shared/shared-map.tokens";
import { MapLayerProviderComponent } from "../map-layer-provider/map-layer-provider.component";
import { AzureMapsImageryProvider } from "./azure-maps-imagery.provider";

@Component({
    selector: "dtm-map-azure-maps-layer:not([provider])",
    template: "",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AzureMapsLayerComponent extends MapLayerProviderComponent<Partial<AzureMapsOptions>> implements OnChanges, OnInit {
    @Input({ required: false }) public options: Partial<AzureMapsOptions> = AZURE_MAPS_LAYER_OPTIONS;
    @Input({ required: false }) public provider = AzureMapsImageryProvider;
    public index = 0;
    private readonly azureMapsSubscriptionKey = inject(AZURE_MAPS_SUBSCRIPTION_KEY);

    public ngOnChanges(): void {
        this.options = { ...this.options, subscriptionKey: this.azureMapsSubscriptionKey };
        super.ngOnChanges();
    }

    public ngOnInit(): void {
        this.options = { ...this.options, subscriptionKey: this.azureMapsSubscriptionKey };
        this.rebuildLayer();
    }
}
